import Vue from "vue";

export default {
  install(vue) {
    Vue.prototype.isMobile = function () {
      let regExpMatchArray = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return regExpMatchArray && regExpMatchArray.length > 0;
    }
    Vue.prototype.getUserInfo = function () {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      return userInfo || null;
    }

    Vue.prototype.hasAdmin = function () {
      if (!Vue.prototype.getUserInfo()) {
        return false;
      }
      return Vue.prototype.getUserInfo().isAdmin;
    }

    /**
     * 时间格式化
     *
     * @param date  指定时间
     * @param fmt   格式化格式
     * @returns {*}
     */
    Vue.prototype.format = function (date, fmt) {
      let o = {
        "M+": date.getMonth() + 1,                //月份
        "d+": date.getDate(),                    //日
        "h+": date.getHours(),                   //小时
        "m+": date.getMinutes(),                 //分
        "s+": date.getSeconds(),                 //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds()             //毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
      }
      return fmt;
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Common.js